import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { IUser } from "../utils/interfaces";
import apiFetcher from "../utils/apiFetcher";
interface IAuthState {
  isAuthenticated: boolean;
  user: IUser | null;
}
const initialState: IAuthState = {
  isAuthenticated: false,
  user: null,
};


const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    logout(state) {
      if (state.isAuthenticated && state.user) {
        apiFetcher.post("/user/logout/");
      }
      state.isAuthenticated = false;
      state.user = null;
    },
  },
});

// selectors
export const { login, logout } = authSlice.actions;
export const selectAuthSlice = (state: RootState) => state.auth;
export default authSlice.reducer;
